
import { Component, Prop, Vue, Watch } from "nuxt-property-decorator";

let accordionIdCounter = 0;

@Component({})
export default class Accordion extends Vue {
  @Prop({ default: "" }) readonly title!: string;
  @Prop({ default: "" }) readonly value!: string;
  @Prop({ default: false }) readonly expanded!: boolean;

  isExpanded = this.expanded;
  instanceId = accordionIdCounter++;

  get contentId(): string {
    return `accordion-${this.instanceId}-content`;
  }

  @Watch("expanded")
  onExpandedChange(val: boolean) {
    this.isExpanded = val;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
    this.$emit("toggle", { value: this.value, expanded: this.isExpanded });
  }
}
